// Dynamically inject /marketplace/latest.js. Called from main.js after
// window.CONFIGURATION is set so latest.js can read CONFIGURATION.release
// synchronously without racing main.js.
const script = document.createElement("script");
script.type = "module";
script.src = "/marketplace/latest.js";
document.head.appendChild(script);
